/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');


      $('.hp-wrapper').on('click',function(){
         $('html, body').animate({scrollTop: $('.hp-wrapper').height()}, 1000);
      });


      $('.owl-carousel.single-slide').owlCarousel({
        loop:true,
        margin:10,
        autoplay:true,
        autoplayTimeout:3000,
        autoplayHoverPause:false,
        nav: false,
        items: 1
      });

      $('.owl-carousel:not(.single-slide)').owlCarousel({
          margin: 10,
          nav: true,
          navText: ["<span class='fa fa-angle-left'></span>","<span class='fa fa-angle-right'></span>"],
          responsiveClass:true,
          responsive:{
              0:{
                  items:1,
              },
              576:{
                items:2
              },
              768:{
                  items:3
              }
          }
      });

      $('a[data-toggle="tab"][href="#sr"]').on('shown.bs.tab', function (e) {
        goog_report_conversion();
      });

      function resizeEvent(){
          var hpBanner = $('.hp-wrapper .banner-wrap .bg-img').first();
          if(hpBanner.length){
              if($(window).width() < 576){
                hpBanner.css('background-image', "url("+hpBanner.attr('data-portrait-img')+")");
              }else{
                hpBanner.css('background-image', "url("+hpBanner.attr('data-landscape-img')+")");
              }
          }

      }

      resizeEvent();
      $( window ).resize(function() {
        resizeEvent();
      });

      if(window.innerWidth < 576){
          $('.menu-main-menu-container .menu-item-has-children').each(function(){
             $(this).find('a').first().attr('href','#');
          });
      }
      $( '.swipebox' ).swipebox();
      //cookie bar
      //$('.cookie-message').cookieBar({ closeButton : '.cookie-bar-close' });
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
